import React, { createContext, useState, useContext } from 'react';

   const DesignContext = createContext();

   export const DesignProvider = ({ children }) => {
     const [design, setDesign] = useState({
     name: '',
     description: '',
     components: [],
     connections: [],
	});

     const addComponent = (component) => {
       setDesign((prev) => ({ ...prev, components: [...prev.components, component] }));
     };

    const updateComponent = (updatedComponent) => {
       setDesign((prev) => ({
         ...prev,
         components: prev.components.map((c) => (c.id === updatedComponent.id ? updatedComponent : c)),
       }));
     };

    const addConnection = (connection) => {
       setDesign((prev) => ({ ...prev, connections: [...prev.connections, connection] }));
     };
	 
	const updateConnection = (updatedConnection) => {
    setDesign((prev) => ({
      ...prev,
      connections: prev.connections.map((conn) =>
        conn.id === updatedConnection.id ? updatedConnection : conn
      ),
		}));
	};

   const deleteConnection = (connectionId) => {
     setDesign((prev) => ({
       ...prev,
       connections: prev.connections.filter((conn) => conn.id !== connectionId),
     }));
	};

     const value = {
       design,
       setDesign, //  Add setDesign to the context value
       addComponent,
       updateComponent,
       addConnection,
	   updateConnection,
	   deleteConnection,
     };

     return <DesignContext.Provider value={value}>{children}</DesignContext.Provider>;
   };

   export const useDesign = () => useContext(DesignContext);